import CreatorQuickLinkComponent from "./CreatorQuickFileComponent";
export default CreatorQuickLinkComponent;
